import React from 'react';
import PropTypes from 'prop-types';

import PropertyPanel from 'app/shared/model/PropertyPanel';

import {
    Text,
    IconChevronRightCircle,
} from '@zillow/constellation';

import {
    StyledContainer,
    StyledContent,
} from './StyledComponents';

const propTypes = {
    panelModel: PropTypes.shape({
        isDisabled: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        urlPath: PropTypes.string.isRequired,
    }),
};

const defaultProps = {
    panelModel: PropertyPanel({}),
};

const LayoutWithoutSubTitle = ({
    panelModel,
}) => {
    const {
        isDisabled,
        message,
        title,
    } = panelModel;

    return (
        <StyledContainer className="LayoutWithoutSubTitle">
            <StyledContent>
                <Text
                    fontColor="brand"
                    fontType="bodyHeading"
                >
                    {title}
                </Text>

                <Text
                    as="div"
                    fontType="bodySmall"
                >
                    {message}
                </Text>
            </StyledContent>

            {isDisabled === false && <IconChevronRightCircle fontColor="brand" size="sm" />}
        </StyledContainer>
    );
};

LayoutWithoutSubTitle.propTypes = propTypes;
LayoutWithoutSubTitle.defaultProps = defaultProps;

export default LayoutWithoutSubTitle;
